<template>
    <div class="contrast-list-page">
        <div class="contrast-list-topbar">
            <!-- 1、顶部菜单栏 -->
            <div class="contrast-list-title-bar discuss-title-bar-normal dsp-flex">
                <div class="title-side title-gray detail-title-left">
                    <span class="title-back discuss-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                </div>
                <div class="title-middle">
                    <span>对比记录</span>
                </div>
                <div class="title-side title-green">
                    <span @click="clickCreateContrast">新建对比</span>
                </div>
            </div>
            <!-- 2、搜索框 -->
            <div class="contrast-list-search">
                <search-input 
                    v-bind:className="'contrast-list-search-input'"
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
        </div>
        <!-- 3、对比列表内容区域 -->
        <div class="contrast-list" v-if="contrastSearchList.length > 0">
            <contrast-list-item v-for="item in contrastSearchList" v-bind:key="item.id" :source="item"></contrast-list-item>
        </div>
        <div class="contrast-list" v-else>
            <contrast-virtual-list
                v-bind:gotData="gotContrastList"
                v-bind:listData="contrastList"
                v-bind:startContrastFunc="clickCreateContrast">
            </contrast-virtual-list>
        </div>

        <van-popup v-bind:value="showContrastCreatePanel" class="layout-contrast-create-pop-box" @click-overlay="clickContrastCreateOverlay">
            <vant-contrast-create-pop></vant-contrast-create-pop>
        </van-popup>

        <router-view></router-view>
    </div>
</template>

<script>
import SearchInput from '../../components/SearchInput.vue'
import ContrastVirtualList from '../../layouts/contrast/ContrastVirtualList.vue'
import VantContrastCreatePop from '../../layouts/vant/VantContrastCreatePop.vue'
import ContrastListItem from '../../components/contrast/ContrastListItem.vue'
import { CONTRAST_DOM } from '../../modules/dom'
import { MIX } from '../../modules/utils'
export default {
    name: 'ContrastList',
    components: { SearchInput, ContrastVirtualList, VantContrastCreatePop, ContrastListItem },
    computed: {
        searchData() {
            return this.$store.state.search.searchData;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        showContrastCreatePanel() {
            return this.$store.state.contrast.showContrastCreatePanel;
        },
        gotContrastList() {
            return this.$store.state.contrast.gotContrastList;
        },
        contrastList() {
            return this.$store.state.contrast.contrastList;
        },
        contrastSearchList() {
            return this.$store.state.contrast.contrastSearchList;
        }
    },
    data() {
        return {
            searchInputId: 'contrastSearchInput',
            searchText: '',
        }
    },
    mounted: function() {
        this.$store.dispatch('contrast/initContrastList', {
            cb: function() {
                CONTRAST_DOM.updateContrastList();
            }
        });
        setTimeout(() => {
            MIX.trackPageViewed('CompareListPage');
        }, 20);
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
    },
    methods: {
        clickBack() {
            let curUrl = this.$router.history.current.fullPath;
                curUrl = curUrl.replace('/contrastlist', '');
            this.$router.replace(curUrl);
        },
        inputSearch(word) {
            this.searchText = word;
            if(this.searchText != '') {
                this.$store.dispatch('contrast/getSearchContrastList', word);
            }else {
                this.$store.state.contrast.contrastSearchList.splice(0);
            }
        },
        clickCreateContrast() {
            this.$bus.emit('resetContrastStatus');
            this.$store.dispatch('contrast/resetContrastDefaultData');
            this.$store.state.contrast.showContrastCreatePanel = true;
        },
        clickContrastCreateOverlay() {
            this.$store.state.contrast.showContrastCreatePanel = false;
        }
    }
}
</script>
